module.exports = __webpack_public_path__ + "static/media/w_sort_open.e5943cc5.svg";